import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../../constants/assets/DriverDetailsContainers";
import variables from "../../../../constants/assets/variables";
import Checkbox from "sushiweb/InputTypes/Checkbox";
import PlusCircle from "sushiweb/Icons/all/PlusCircle";
import Delete from "sushiweb/Icons/all/Delete";
import {
  DeleteBar,
  FieldsContainer,
  FlexContainer,
  FieldsSection,
} from "../../../../constants/assets/containers";
import InfiniteScrollDropdown from "../../../Common/InfiniteScrollDropdown";
import { getPath, isValNull } from "../../../../utils";
import { useHistory, useParams } from "react-router";

const DriverLocalitiesEditState = ({
  localities,
  editState,
  cityList,
  localityList,
  saveState,
  setSaveState,
  updateDriverLocalitiesDetails,
  getDriverLocalitiesDetails,
  driverId,
  driverBasicDetails,
  getCityList,
  getLocalityList,
  nextPageCity,
  nextPageLocality,
  activeCity,
  activeLocality,
  getCity,
  getLocality,
  setStatus,
}) => {
  const history = useHistory();
  const { id } = useParams();
  const [primaryLocalities, setPrimaryLocalities] = useState([]);
  const [secondaryLocalities, setSecondaryLocalities] = useState([]);
  const [priorityFlag, setPriorityFlag] = useState([]);
  const localityState = {
    active: false,
    freeze_locality: false,
    locality_id: "",
    city_id: "",
  };

  const handleChange = (key, val, indexParam) => {
    const index = indexParam[0];
    const values = JSON.parse(JSON.stringify(secondaryLocalities));
    const pFlags = [...priorityFlag];
    if (key === "city_id") {
      values[index]["locality_id"] = "";
      pFlags[index] = 1;
    } else {
      pFlags[index] = 0;
    }
    values[index][key] = val;
    setPriorityFlag(pFlags);
    setSecondaryLocalities(values);
  };

  const checkValidations = (locArr) => {
    let flag = 0;
    for (let i = 0; i < locArr.length; i++) {
      if (isValNull(locArr[i].locality_id) || isValNull(locArr[i].city_id)) {
        flag = 1;
        break;
      }
    }
    return flag;
  };

  const handleSubmit = () => {
    const validationError = checkValidations(secondaryLocalities);
    if (!validationError) {
      updateDriverLocalitiesDetails(driverId, secondaryLocalities).then(() => {
        getDriverLocalitiesDetails(driverId);
      });
    } else {
      setStatus({ type: "error", message: "Please input all the fields" });
    }
    setSaveState(false);
  };

  const handleSetPriorityFLag = (val, index) => {
    const pFlags = [...priorityFlag];
    pFlags[index] = val;
    setPriorityFlag(pFlags);
  };

  const checkIfFieldDisabled = (index) => {
    return index < localities.length - 1;
  };

  const getFields = (type, locality, index = 0) => {
    return (
      <FieldsContainer>
        <FieldHolder justify="flex-start">
          <span>City</span>
          <InfiniteScrollDropdown
            id="cityFilterDropdown"
            className="sushi-dropdown"
            priorityFlag={true}
            appliedFilters={{}}
            getActiveList={getCityList}
            nextPage={nextPageCity}
            disabled={checkIfFieldDisabled(index)}
            makeNoInitialCall={locality.city_name ? true : false}
            resKey="cities"
            modalState={!locality.city_name ? "Filter" : "Add"}
            keyName="city_id"
            labelKey="city_name"
            value={
              locality.city_name
                ? { city_id: locality.city_id, city_name: locality.city_name }
                : null
            }
            getDataLabelKey="city.city_name"
            keyTypeToSet="id"
            label=""
            handleChange={handleChange}
            getActiveItemById={getCity}
            remoteSearchApplicable={false}
            remoteSearchKey="startswith"
            activeFilters={
              locality.city_id ? { city_id: locality.city_id } : {}
            }
            activeElement={activeCity}
            extraParams={[index]}
          />
        </FieldHolder>
        <FieldHolder justify="flex-start">
          <span>Locality</span>
          <InfiniteScrollDropdown
            id="localityFilterDropdown"
            className="sushi-dropdown"
            disabled={checkIfFieldDisabled(index)}
            appliedFilters={
              locality.city_id ? { city_id: locality.city_id } : {}
            }
            priorityFlag={priorityFlag[index]}
            setPriorityFlag={(val) => handleSetPriorityFLag(val, index)}
            getActiveList={getLocalityList}
            nextPage={nextPageLocality}
            resKey="localities"
            modalState={!locality.locality_name ? "Filter" : "Add"}
            keyName="locality_id"
            labelKey="locality_name"
            makeNoInitialCall={locality.locality_id ? true : false}
            getDataLabelKey="locality.locality_name"
            value={
              locality.locality_name
                ? {
                    locality_id: locality.locality_id,
                    locality_name: locality.locality_name,
                  }
                : null
            }
            keyTypeToSet="id"
            label=""
            handleChange={handleChange}
            remoteSearchApplicable={false}
            getActiveItemById={getLocality}
            remoteSearchKey="startswith"
            activeFilters={
              locality.locality_id ? { locality_id: locality.locality_id } : {}
            }
            activeElement={activeLocality}
            extraParams={[index]}
          />
        </FieldHolder>
        <FieldHolder justify="flex-start">
          <span>Active</span>
          <Checkbox
            value="active"
            color={variables.red500}
            disabled={
              type === "PRIMARY" ||
              getPath(driverBasicDetails, "zone_enabled", false)
            }
            checked={locality["active"]}
            onChange={(e) => handleChange("active", e["active"], [index])}
            className="sushi-checkbox"
          />
        </FieldHolder>
        <FieldHolder justify="flex-start">
          <span>Freeze</span>
          <Checkbox
            value="freeze_locality"
            disabled={
              type === "PRIMARY" ||
              getPath(driverBasicDetails, "zone_enabled", false)
            }
            color={variables.red500}
            checked={locality["freeze_locality"]}
            onChange={(e) =>
              handleChange("freeze_locality", e["freeze_locality"], [index])
            }
            className="sushi-checkbox"
          />
        </FieldHolder>
      </FieldsContainer>
    );
  };

  const handleSecondaryLocalityAdd = () => {
    let values = [...secondaryLocalities];
    values.push({ ...localityState });
    setSecondaryLocalities(values);
  };

  const handleDeletionSecondaryLocality = (index) => {
    const values = [...secondaryLocalities];
    values.splice(index, 1);
    setSecondaryLocalities(values);
  };

  const canLocalityBeDeleted = (index) => {
    const secLocalities = localities.filter(
      (item) => item.locality_type.toLowerCase() === "secondary"
    );
    return index > secLocalities.length - 1;
  };

  const handleClick = () => {
    history.push(`/delivery-drivers/${id}/details`);
  };

  //to handle click on save button
  useEffect(() => {
    saveState && handleSubmit();
  }, [saveState]);

  useEffect(() => {
    if (localities.length > 0) {
      const primaryLoc = localities.filter(
        (item) => item.locality_type === "PRIMARY"
      );
      const secondaryLoc = localities.filter(
        (item) =>
          item.locality_type && item.locality_type.toLowerCase() !== "primary"
      );
      const updatedSecondaryLocs = secondaryLoc.map(
        ({
          active,
          freeze_locality,
          id,
          locality_id,
          city_name,
          locality_name,
        }) => ({
          active,
          freeze_locality,
          id,
          locality_id,
          city_name,
          locality_name,
        })
      );
      primaryLoc.forEach((item) => {
        item.city_id = driverBasicDetails.city_id;
      });
      updatedSecondaryLocs.forEach((item) => {
        item.city_id = driverBasicDetails.city_id;
      });
      //to set pFlags for infintescrollDropdown, to call localities only when city gets selected
      const pFlags = [...priorityFlag];
      localities.forEach((item, index) => {
        pFlags[index] = 0;
      });
      setPriorityFlag(pFlags);
      setPrimaryLocalities(primaryLoc);
      setSecondaryLocalities(updatedSecondaryLocs);
    }
  }, [localities]);

  return (
    <DriverLocalitiesDetailsContainer
      className="containsDropdown"
      editState={true}
    >
      {getPath(driverBasicDetails, "zone_enabled", false) && (
        <h3 className="medium mb-40">
          To edit zone/locality go to{" "}
          <span onClick={handleClick} className="edit-options cursor-pointer">
            details section
          </span>
        </h3>
      )}
      {primaryLocalities.map((locality, index) => {
        return (
          <PrimaryLocalityContainer key={index}>
            <p>PRIMARY LOCALITY</p>
            {getFields("PRIMARY", locality)}
          </PrimaryLocalityContainer>
        );
      })}
      {secondaryLocalities.map((locality, index) => {
        return (
          <SecondaryLocalityContainer key={index}>
            <FlexContainer className="mb-12">
              <p>{`SECONDARY LOCALITY ${index + 1}`}</p>
              {canLocalityBeDeleted(index) && (
                <DeleteBar
                  onClick={() => handleDeletionSecondaryLocality(index)}
                >
                  <Delete
                    className="mr-10"
                    size={20}
                    color={variables.red500}
                  />
                  <span>Delete</span>
                </DeleteBar>
              )}
            </FlexContainer>
            {getFields("SECONDARY", locality, index)}
          </SecondaryLocalityContainer>
        );
      })}
      {!getPath(driverBasicDetails, "zone_enabled", false) && (
        <AddLocalitySection
          onClick={handleSecondaryLocalityAdd}
          justify="flex-start"
        >
          <PlusCircle color={variables.red500} size={20} />
          <span>ADD SECONDARY LOCALITY</span>
        </AddLocalitySection>
      )}
    </DriverLocalitiesDetailsContainer>
  );
};

const DriverLocalitiesDetailsContainer = styled(DriverBasicDetailsContainer)`
  .MuiAutocomplete-root {
    width: 50% !important;
  }
`;

const SecondaryLocalityContainer = styled.div`
  & > div > p {
    letter-spacing: 0.18rem;
  }
`;

const PrimaryLocalityContainer = styled(FieldsSection)`
  .customDropdown {
    pointer-events: none;
  }
`;

const AddLocalitySection = styled(FlexContainer)`
  span {
    color: ${variables.red500};
    font-weight: 500;
    margin-left: 5px;
    letter-spacing: 1.4px;
  }
  cursor: pointer;
  margin: 0.65rem 0 1.25rem 0;
`;

export default DriverLocalitiesEditState;
